var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.available)?_c('span',[_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.timeStr))]),_vm._v("\n  "+_vm._s(_vm.tzName)+"\n")]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1076e24e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Clock.vue
// module id = dZys
// module chunks = 3